export default "__VITE_ASSET__C7H1TUr$__"